import { useState, useEffect } from 'react'

export const DEBOUNCE_BUSQUEDA_MS = 400

/**
 * Retrasa la propagación de un valor hasta que deja de cambiar por `delay` ms.
 *
 * Útil para evitar una request por cada tecla cuando un efecto depende de un
 * valor que se actualiza en cada `onChange`.
 *
 * @param {*} valor Valor a debouncear.
 * @param {number} delay Milisegundos de espera desde el último cambio.
 * @returns {*} El valor una vez estabilizado.
 */
export const useDebounce = (valor, delay) => {
  const [valorDebounceado, setValorDebounceado] = useState(valor)

  useEffect(() => {
    const temporizador = setTimeout(() => {
      setValorDebounceado(valor)
    }, delay)

    return () => {
      clearTimeout(temporizador)
    }
  }, [valor, delay])

  return valorDebounceado
}
